import type { MessageTemplate } from "@features/templates/api";
import type { FormInstance } from "antd";
import { Form, Input, Select, Switch } from "antd";
import { memo, useEffect } from "react";

interface TemplateFormProps {
  form: FormInstance;
  initialData: MessageTemplate | null;
}

const createDefaults = { channel: "email", is_active: true };

const TemplateForm = memo(function TemplateForm({ form, initialData }: TemplateFormProps) {
  useEffect(() => {
    if (initialData) {
      form.setFieldsValue(initialData);
    } else {
      form.setFieldsValue(createDefaults);
    }
  }, [form, initialData]);

  return (
    <Form form={form} layout="vertical">
      <Form.Item name="name" label="Название" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="subject" label="Тема">
        <Input />
      </Form.Item>
      <Form.Item name="body" label="Текст" rules={[{ required: true }]}>
        <Input.TextArea rows={6} />
      </Form.Item>
      <Form.Item name="channel" label="Канал">
        <Select
          options={[
            { value: "email", label: "Email" },
            { value: "telegram", label: "Telegram" },
            { value: "both", label: "Все" },
          ]}
        />
      </Form.Item>
      <Form.Item name="is_active" label="Активен" valuePropName="checked">
        <Switch />
      </Form.Item>
    </Form>
  );
});

export default TemplateForm;
